import { useTranslation } from "react-i18next";
import { MembershipCard } from "@/components/MembershipCard";
import { MembershipActivity } from "@/components/MembershipActivity";
import screen from "@/layout/screen.module.css";

/**
 * "My membership" — the student's own entitlement page (issue #249),
 * reachable from the SideNav at `/membership` and guarded by
 * `RequireAuth` in `App.tsx`.
 *
 * Composes the entitlement as a distinct membership card (status, end
 * date, credit balance) with the sanitized activity ledger in its own
 * surface right after (issue #283).
 */
export function MembershipScreen() {
  const { t } = useTranslation();

  return (
    <div
      className={screen.capped}
      style={{
        padding: "var(--space-6) var(--space-4)",
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-5)",
      }}
    >
      <div>
        <div
          style={{
            font: "var(--fw-regular) var(--fs-xs)/1 var(--font-body)",
            color: "var(--text-faint)",
          }}
        >
          {t("membership.eyebrow")}
        </div>
        <div
          style={{
            font: "var(--fw-extra) var(--fs-2xl)/1.1 var(--font-display)",
            color: "var(--text-strong)",
            letterSpacing: "var(--ls-tight)",
            marginTop: 4,
          }}
        >
          {t("membership.title")}
        </div>
        <div
          style={{
            font: "var(--fw-regular) var(--fs-sm)/1.5 var(--font-body)",
            color: "var(--text-muted)",
            marginTop: 6,
          }}
        >
          {t("membership.subtitle")}
        </div>
      </div>

      <MembershipCard />
      <MembershipActivity />
    </div>
  );
}
